import { addAsync as _addAsync, updateAsync as _updateAsync } from "../../api";

const BASE_URL = "/coc/requests";

export async function addAsync(requestId, payload) {
    return _addAsync({ url: `${BASE_URL}/${requestId}/evidences/${payload.cocRequestEvidencesId}/approvals`, data: payload });
}

export async function updateAsync(requestId, payload) {
    return _updateAsync({ url: `${BASE_URL}/${requestId}/evidences/${payload.cocRequestEvidencesId}/approvals/${payload.id}`, data: payload });
}
